/**
 * Legend:
 * 1. Image: Eksempel:
 *    https://app.dib.no/faglitteratur/skatterett-for-okonomistudenter-2021/e5b0b1b9-6d3b-498d-8693-48b60645dac5
 * 2. AutoLinkNone: Vises som ren, ustylet tekst. Representerer en automatisk generert
 *    lenke som er deaktivert manuelt i dibadmin
 * 3. AutoLink: Automatisk generert lenke, vises med stiplede linjer. Eksempel:
 *    https://app.dib.no/tema/firmabil-fri-bil/c2c9abd3-c4bb-4dc3-ba74-66c9ab8efcfe
 * 4. PreviewLink: Visuelt identisk med AutoLink. Henter et manuelt valgt utdrag fra et topic
 * 5. FileRef: Lenke til en fil, typisk XLSX, XDOC, PDF
 *    Eksempel: https://app.dib.no/standard/ifrs-9-finansielle-instrumenter/406709be-b9b7-48d9-a50d-b35a2a8a6c02
 * 6. JumpLink: Anchor-link til innhold på samme side. Vises med vanlig link-styling. Eksempel:
 *    Lenkene i Table of contents her: https://app.dib.no/standard/ifrs-blue-book-2026/f0e8e993-0769-4285-8cf0-0726c8a4e749/segment/ifrs1
 * 7. AutoLinkNav: Fullverdig lenke til et topic. Normal link-styling, normal navigering.
 * 8. IfrsDefLink: Merkelig liten lenke med "edu" i superscript og stiplet linje. Eksempel:
 *    https://app.dib.no/standard/ifrs-blue-book-2026/f0e8e993-0769-4285-8cf0-0726c8a4e749/segment/ifrs1
 * 9. IfrsFootnote: Finnes i to varianter, klarer bare finne én variant i det fri ("E1" i superscript,
 *    stiplet linje). Eksempel i ledd 7:
 *    https://app.dib.no/standard/ifrs-blue-book-2026/f0e8e993-0769-4285-8cf0-0726c8a4e749/segment/ifrs1#ifrs01_7
 * 10. ExmarkLink: Virkelig en rar en. Rendres i utgangspunktet kun ut i sidepanelet. Hele funksjonaliteten her
 *     bør opp til diskusjon. Visuell visning på dib: fire prikker med en pil under. Komponenten brukes som en
 *     representasjon på innhold som skjules, men som kan hentes fram ved behov. Veldig buggy etter et par trykk.
 *     Eksempel: Trykk på en av de små snakkeboblene i dette topicet, og se i sidepanelet:
 *     https://app.dib.no/lov/aksjeloven/da3db617-f9a3-4668-93e6-bbb2e37b928f/segment/kap1
 * 11. ExternalHref: Utgående lenke med pil. Eksempel:
 *     https://app.dib.no/lov/aksjeloven/da3db617-f9a3-4668-93e6-bbb2e37b928f/segment/kap1
 * 12. Xbox: Ekspanderbar innholdsboks. Kan defaulte til lukket og åpen. Eksempel:
 *     https://app.dib.no/tema/firmabil-fri-bil/c2c9abd3-c4bb-4dc3-ba74-66c9ab8efcfe#2e558364-9125-47e6-b4d7-2353f22d7154
 * 13. Table: Tabellkomponent som utvides med "Vis i fullskjerm" dersom innholdet tar for stor plass. Finnes i to varianter
 *     i mockTopic. Eksempel:
 *     https://app.dib.no/tema/satser/f1e7f5e4-3f4a-4095-9ecd-9b79e18c7b08/segment/2a00685c-2fd5-40ef-9f00-4c9aba8b7eeb
 * 14. Booktags: En form for stikkord (i bøker) som er relevante for innholdet
 *     Eksempel: https://app.dib.no/skatte-abc/skatte-abc-2025-26/d4f1ce57-aab1-4147-9218-d632f3f1cd1b/segment/a-1
 * 15. XFootnote: Ikke-interaktiv snakkeboble som kun viser "title"-teksten sin...
 *     Eksempel: https://app.dib.no/standard/ifrs-9-finansielle-instrumenter/406709be-b9b7-48d9-a50d-b35a2a8a6c02#cf3fd52d-c276-43dd-a47a-3ee89eca053d
 * 16. PageBreak: Brukes kun til å angi sideskift i Word-generering. Vises ikke i GUI.
 *
 * AUGMENTATIONS: Parsing-metodikk som ikke er en 1-til-1 konvertering som ikke mapper en json-node til en
 * React-komponent, men som kan utvide en json-node med flere barnenoder + rendrer en React-komponent av resultatet.
 *
 * Augmentation 1: AccountingTable. Kan inneholde TRE separate rad-grupper: Konto, Lønn, MVA. I tilleg
 *     kan den inneholde en rad på bunnen som viser hvilke skatteregler som er relevante. Eksempel:
 *     https://app.dib.no/tema/aviser-til-ansatte/552c57b4-a692-47e6-bcc9-c010f32f1c93
 * Augmentation 2: Stikkord. En samling av stikkord. text-overflow ellipsis, kan utvides. Se stikkordene under AccountingTable
 *     i samme eksempel som AccountingTable
 * Augmentation 3: SectionIconLinks. Navigasjonslenker som vises i sammenheng med en tittel. Eksempel:
 *     https://app.dib.no/lov/aksjeloven/da3db617-f9a3-4668-93e6-bbb2e37b928f/segment/kap1#kap1
 */

export const mockTopic = {
    formatVersion: "2.0.0",
    sourceFormat: "json",
    eCount: 93,
    version: "2.0",
    topicId: "7c9a75fa-61d4-4703-868b-f300b3df9a57",
    selectId: "",
    segmentId: "",
    id: "82abb985-bfe6-4acb-9122-5e4ade719b60",
    resourceTypeId: "19",
    supplierId: "1",
    supplier: "DIBkunnskap",
    topictypeId: "29",
    topictype: "Tema",
    RowVersion: "AAAAAADSN5Q=",
    access: true,
    companylookup: false,
    name: "Mock topic — component overview",
    language: "no",
    origin: "",
    rootObjects: [
        {name: "xdoc", id: "xdoc;", className: "doccontainer"},
        {name: "xdesc", id: "xdesc;", className: "desccontainer"},
    ],
    descroot: [{id: "xdesc;"}],
    root: [{id: "xdoc;"}],
    elements: {
        "xdesc;": {
            attributes: {class: "desccontainer", id: "xdesc;"},
            children: [],
            name: "div",
        },
        "xdoc;": {
            attributes: {class: "doccontainer", id: "xdoc;"},
            children: [{id: "mock-root"}],
            name: "div",
        },
        "mock-root": {
            attributes: {id: "mock-root", class: "level"},
            children: [
                {id: "mock-h1"},
                {id: "rr-section"},
                {id: "aug-section"},
            ],
            name: "section",
        },
        "mock-h1": {
            attributes: {id: "mock-h1"},
            children: [{text: "Mock topic — component overview"}],
            name: "h1",
        },
        "rr-section": {
            attributes: {id: "rr-section", class: "level"},
            children: [
                {id: "rr-h2"},
                {id: "rr-1"},
                {id: "rr-2"},
                {id: "rr-3"},
                {id: "rr-4"},
                {id: "rr-5"},
                {id: "rr-6"},
                {id: "rr-7"},
                {id: "rr-8"},
                {id: "rr-9"},
                {id: "rr-10"},
                {id: "rr-11"},
                {id: "rr-12"},
                {id: "rr-13"},
                {id: "rr-13-wide"},
                {id: "rr-14"},
                {id: "rr-15"},
                {id: "rr-16"},
            ],
            name: "section",
        },
        "rr-h2": {
            attributes: {id: "rr-h2"},
            children: [{text: "Render Rules"}],
            name: "h2",
        },
        "rr-1": {
            attributes: {id: "rr-1", class: "level"},
            children: [
                {id: "rr-1-h"},
                {id: "0826e7e3-88c0-48e0-8dc5-c03e92082b35"},
            ],
            name: "section",
        },
        "rr-1-h": {
            attributes: {id: "rr-1-h"},
            children: [{text: "1. Image"}],
            name: "h3",
            // Real life example: https://app.dib.no/faglitteratur/skatterett-for-okonomistudenter-2021/e5b0b1b9-6d3b-498d-8693-48b60645dac5
        },
        "0826e7e3-88c0-48e0-8dc5-c03e92082b35": {
            attributes: {
                alt: "",
                height: "600",
                id: "0826e7e3-88c0-48e0-8dc5-c03e92082b35",
                src: "https://static.dib.no/dibimages/d5ab33d0-46cd-44b1-a0af-5dd25802b831.png",
                width: "600",
            },
            children: [],
            name: "img",
        },
        "rr-2": {
            attributes: {id: "rr-2", class: "level"},
            children: [{id: "rr-2-h"}, {id: "rr-2-p"}],
            name: "section",
        },
        "rr-2-h": {
            attributes: {id: "rr-2-h"},
            children: [{text: "2. AutoLinkNone"}],
            name: "h3",
        },
        "rr-2-p": {
            attributes: {id: "rr-2-p"},
            children: [{id: "rr-2-a"}],
            name: "p",
        },
        "rr-2-a": {
            attributes: {
                id: "rr-2-a",
                class: "auto-link-none",
                href: "#",
            },
            children: [{text: "aksjeloven"}],
            name: "a",
        },
        "rr-3": {
            attributes: {id: "rr-3", class: "level"},
            children: [{id: "rr-3-h"}, {id: "rr-3-p"}],
            name: "section",
        },
        "rr-3-h": {
            attributes: {id: "rr-3-h"},
            children: [{text: "3. AutoLink"}],
            name: "h3",
        },
        "rr-3-p": {
            attributes: {id: "rr-3-p"},
            children: [{id: "eb9919d0-e903-4dbb-9b51-0f8cb2996170"}],
            name: "p",
        },
        "eb9919d0-e903-4dbb-9b51-0f8cb2996170": {
            attributes: {
                class: "auto-link",
                id: "eb9919d0-e903-4dbb-9b51-0f8cb2996170",
            },
            children: [{text: "asl. §1-1"}],
            name: "a",
        },
        "rr-4": {
            attributes: {id: "rr-4", class: "level"},
            children: [{id: "rr-4-h"}, {id: "rr-4-p"}],
            name: "section",
        },
        "rr-4-h": {
            attributes: {id: "rr-4-h"},
            children: [{text: "4. PreviewLink"}],
            name: "h3",
        },
        "rr-4-p": {
            attributes: {id: "rr-4-p"},
            children: [{id: "6f9d2059-d144-4115-837a-cfdc309cb3de"}],
            name: "p",
        },
        "6f9d2059-d144-4115-837a-cfdc309cb3de": {
            attributes: {
                class: "preview",
                id: "6f9d2059-d144-4115-837a-cfdc309cb3de",
            },
            children: [
                {
                    text: "Uttalelser fra ledelsen | Skriftlige uttalelser om ledelsens ansvar",
                },
            ],
            name: "a",
        },
        "rr-5": {
            attributes: {id: "rr-5", class: "level"},
            children: [{id: "rr-5-h"}, {id: "rr-5-p"}],
            name: "section",
        },
        "rr-5-h": {
            attributes: {id: "rr-5-h"},
            children: [{text: "5. FileRef"}],
            name: "h3",
        },
        "rr-5-p": {
            attributes: {id: "rr-5-p"},
            children: [{id: "13f64129-7f6d-4774-9656-9f5a04ebaf4b"}],
            name: "p",
        },
        "13f64129-7f6d-4774-9656-9f5a04ebaf4b": {
            attributes: {
                class: "nav",
                id: "13f64129-7f6d-4774-9656-9f5a04ebaf4b",
            },
            children: [{text: "Delårsrapportering oppstillinger - engelsk"}],
            name: "a",
        },
        "rr-6": {
            attributes: {id: "rr-6", class: "level"},
            children: [{id: "rr-6-h"}, {id: "rr-6-p"}],
            name: "section",
        },
        "rr-6-h": {
            attributes: {id: "rr-6-h"},
            children: [{text: "6. JumpLink"}],
            name: "h3",
        },
        "rr-6-p": {
            attributes: {id: "rr-6-p"},
            children: [{id: "rr-6-a"}],
            name: "p",
        },
        "rr-6-a": {
            attributes: {
                id: "rr-6-a",
                class: "ilink nav",
                "data-segment": "",
                "data-id": "rr-12",
            },
            children: [{text: "Hopp til Xbox"}],
            name: "a",
        },
        "rr-7": {
            attributes: {id: "rr-7", class: "level"},
            children: [{id: "rr-7-h"}, {id: "rr-7-p"}],
            name: "section",
        },
        "rr-7-h": {
            attributes: {id: "rr-7-h"},
            children: [{text: "7. AutoLinkNav"}],
            name: "h3",
        },
        "rr-7-p": {
            attributes: {id: "rr-7-p"},
            children: [{id: "dcd3409b-c0b4-4ede-9e42-38f4fd5d3a21"}],
            name: "p",
        },
        "dcd3409b-c0b4-4ede-9e42-38f4fd5d3a21": {
            attributes: {
                class: "nav",
                id: "dcd3409b-c0b4-4ede-9e42-38f4fd5d3a21",
            },
            children: [{text: "Portal KOSTRA-funksjoner"}],
            name: "a",
        },
        "rr-8": {
            attributes: {id: "rr-8", class: "level"},
            children: [{id: "rr-8-h"}, {id: "rr-8-p"}],
            name: "section",
        },
        "rr-8-h": {
            attributes: {id: "rr-8-h"},
            children: [{text: "8. IfrsDefLink"}],
            name: "h3",
        },
        "rr-8-p": {
            attributes: {id: "rr-8-p"},
            children: [{id: "284fb51e-330f-4b8b-99c4-501895331e1e"}],
            name: "p",
        },
        "284fb51e-330f-4b8b-99c4-501895331e1e": {
            attributes: {
                class: "ilink",
                "data-id": "f2d94e61-ab97-406d-b453-6c8b9501d8b1",
                "data-segment": "_edu_notes",
                id: "284fb51e-330f-4b8b-99c4-501895331e1e",
                identify: "true",
            },
            children: [{id: "183482a9-68af-414f-9630-8e7f95ab6942"}],
            name: "a",
        },
        "183482a9-68af-414f-9630-8e7f95ab6942": {
            attributes: {id: "183482a9-68af-414f-9630-8e7f95ab6942"},
            children: [{text: "edu"}],
            name: "sup",
        },
        "rr-9": {
            attributes: {id: "rr-9", class: "level"},
            children: [{id: "rr-9-h"}, {id: "rr-9-p"}],
            name: "section",
        },
        "rr-9-h": {
            attributes: {id: "rr-9-h"},
            children: [{text: "9. IfrsFootnote"}],
            name: "h3",
        },
        "rr-9-p": {
            attributes: {id: "rr-9-p"},
            children: [
                {id: "5a9dccb9-3df6-4e13-9ba5-f54dc409e7d4"},
                {text: " "},
                {id: "rr-9-edu"},
            ],
            name: "p",
        },
        "5a9dccb9-3df6-4e13-9ba5-f54dc409e7d4": {
            attributes: {
                class: "ilink footnote",
                "data-id": "edu_ifrs01_fn0001",
                "data-segment": "edu_d5e26520",
                id: "5a9dccb9-3df6-4e13-9ba5-f54dc409e7d4",
            },
            children: [{text: "E1"}],
            name: "a",
        },
        "rr-9-edu": {
            attributes: {
                id: "rr-9-edu",
                class: "ilink footnote edu",
                "data-id": "edu_ifrs01_fn0001",
                "data-segment": "edu_d5e26520",
            },
            children: [],
            name: "a",
        },
        "rr-10": {
            attributes: {id: "rr-10", class: "level"},
            children: [
                {id: "rr-10-h"},
                {id: "rr-10-p"},
                {id: "rr-10-explanation"},
            ],
            name: "section",
        },
        "rr-10-h": {
            attributes: {id: "rr-10-h"},
            children: [{text: "10. ExmarkLink"}],
            name: "h3",
        },
        "rr-10-explanation": {
            attributes: {id: "rr-10-explanation"},
            children: [{id: "rr-10-explanation-text"}],
            name: "p",
        },
        "rr-10-explanation-text": {
            attributes: {id: "rr-10-explanation-text"},
            children: [
                {
                    text: 'Denne er spesiell. Rendres egentlig kun i sidepanel. Trykk på lenken i "4. PreviewLink" for å se den i aksjon',
                },
            ],
            name: "em",
        },
        "rr-10-p": {
            attributes: {id: "rr-10-p"},
            children: [{id: "7ea0b8aa-89f9-4db2-905a-4ecf8ad3e5bb"}],
            name: "p",
        },
        "7ea0b8aa-89f9-4db2-905a-4ecf8ad3e5bb": {
            attributes: {
                id: "7ea0b8aa-89f9-4db2-905a-4ecf8ad3e5bb",
                class: "ilink preview exmark",
                "data-id": "kapittel_1",
                "data-segment": "kapittel_1",
                title: "Kapittel 1. Innledende bestemmelser",
            },
            children: [{text: "..."}],
            name: "a",
        },
        "rr-11": {
            attributes: {id: "rr-11", class: "level"},
            children: [{id: "rr-11-h"}, {id: "rr-11-p"}],
            name: "section",
        },
        "rr-11-h": {
            attributes: {id: "rr-11-h"},
            children: [{text: "11. ExternalHref"}],
            name: "h3",
        },
        "rr-11-p": {
            attributes: {id: "rr-11-p"},
            children: [{id: "a6b67036-25bc-4bf4-bfcf-3c4bd8dae113"}],
            name: "p",
        },
        "a6b67036-25bc-4bf4-bfcf-3c4bd8dae113": {
            attributes: {
                class: "href",
                id: "a6b67036-25bc-4bf4-bfcf-3c4bd8dae113",
            },
            children: [{text: "Skatteetaten"}],
            name: "a",
        },
        "rr-12": {
            attributes: {id: "rr-12", class: "level"},
            children: [
                {id: "rr-12-h"},
                {id: "b9391882-992d-444e-a5f8-d4dbcf866b5c"},
            ],
            name: "section",
        },
        "rr-12-h": {
            attributes: {id: "rr-12-h"},
            children: [{text: "12. Xbox"}],
            name: "h3",
        },
        "b9391882-992d-444e-a5f8-d4dbcf866b5c": {
            attributes: {
                class: "xbox",
                id: "b9391882-992d-444e-a5f8-d4dbcf866b5c",
            },
            children: [
                {id: "f9bb5f43-5327-456f-8625-e7256dc9453e"},
                {id: "b3f36053-3e80-41a7-9203-cffb8cb3bd99"},
            ],
            name: "figure",
        },
        "f9bb5f43-5327-456f-8625-e7256dc9453e": {
            attributes: {
                class: "xbox-summary",
                id: "f9bb5f43-5327-456f-8625-e7256dc9453e",
            },
            children: [{text: "Dette er en boks"}],
            name: "figcaption",
        },
        "b3f36053-3e80-41a7-9203-cffb8cb3bd99": {
            attributes: {id: "b3f36053-3e80-41a7-9203-cffb8cb3bd99"},
            children: [{id: "7fef97e0-216e-4836-9d62-cc78974040c8"}],
            name: "div",
        },
        "7fef97e0-216e-4836-9d62-cc78974040c8": {
            attributes: {id: "7fef97e0-216e-4836-9d62-cc78974040c8"},
            children: [{text: "Boksinnhold"}],
            name: "p",
        },
        "rr-13": {
            attributes: {id: "rr-13", class: "level"},
            children: [
                {id: "rr-13-h"},
                {id: "9bf598b8-4977-452a-b906-5bf4b480880d"},
            ],
            name: "section",
        },
        "rr-13-h": {
            attributes: {id: "rr-13-h"},
            children: [{text: "13. Table"}],
            name: "h3",
        },
        "9bf598b8-4977-452a-b906-5bf4b480880d": {
            attributes: {
                id: "9bf598b8-4977-452a-b906-5bf4b480880d",
                style: "border-collapse:collapse; width:99.6983%;",
            },
            children: [
                {id: "0b0fab55-4538-4975-9fed-a80dd6df4cd6"},
                {id: "f2488187-7bba-4b9c-809b-7aeb064d1898"},
                {id: "9edbc502-179a-4c69-8ca2-b55c8a79c771"},
            ],
            name: "table",
        },
        "0b0fab55-4538-4975-9fed-a80dd6df4cd6": {
            attributes: {id: "0b0fab55-4538-4975-9fed-a80dd6df4cd6"},
            children: [
                {id: "17dcb204-e40e-4842-b09f-c91cf5a9b870"},
                {id: "020e5cef-f976-44e4-9bea-01a8ebb633f5"},
            ],
            name: "colgroup",
        },
        "17dcb204-e40e-4842-b09f-c91cf5a9b870": {
            attributes: {
                id: "17dcb204-e40e-4842-b09f-c91cf5a9b870",
                style: "width:39.6522%;",
            },
            children: [],
            name: "col",
        },
        "020e5cef-f976-44e4-9bea-01a8ebb633f5": {
            attributes: {
                id: "020e5cef-f976-44e4-9bea-01a8ebb633f5",
                style: "width:60.3478%;",
            },
            children: [],
            name: "col",
        },
        "f2488187-7bba-4b9c-809b-7aeb064d1898": {
            attributes: {id: "f2488187-7bba-4b9c-809b-7aeb064d1898"},
            children: [{id: "90293b52-be3e-433d-98e2-b77d91a368a6"}],
            name: "thead",
        },
        "90293b52-be3e-433d-98e2-b77d91a368a6": {
            attributes: {id: "90293b52-be3e-433d-98e2-b77d91a368a6"},
            children: [
                {id: "7fa6cc91-75af-4e98-9a67-b51a062aa31d"},
                {id: "576a64f1-c6ef-4779-b621-d6c09392f090"},
            ],
            name: "tr",
        },
        "7fa6cc91-75af-4e98-9a67-b51a062aa31d": {
            attributes: {id: "7fa6cc91-75af-4e98-9a67-b51a062aa31d"},
            children: [{text: "Kolonne 1"}],
            name: "th",
        },
        "576a64f1-c6ef-4779-b621-d6c09392f090": {
            attributes: {id: "576a64f1-c6ef-4779-b621-d6c09392f090"},
            children: [{text: "Kolonne 2"}],
            name: "th",
        },
        "9edbc502-179a-4c69-8ca2-b55c8a79c771": {
            attributes: {id: "9edbc502-179a-4c69-8ca2-b55c8a79c771"},
            children: [{id: "04b88b93-b1e2-498c-9ccc-4e7df1e4c9d6"}],
            name: "tbody",
        },
        "04b88b93-b1e2-498c-9ccc-4e7df1e4c9d6": {
            attributes: {id: "04b88b93-b1e2-498c-9ccc-4e7df1e4c9d6"},
            children: [
                {id: "4b6225c9-67c1-443b-b920-a244da25ccd7"},
                {id: "c67bd107-a843-4b68-8d54-841203cfad2c"},
            ],
            name: "tr",
        },
        "4b6225c9-67c1-443b-b920-a244da25ccd7": {
            attributes: {id: "4b6225c9-67c1-443b-b920-a244da25ccd7"},
            children: [{text: "Data 1"}],
            name: "td",
        },
        "c67bd107-a843-4b68-8d54-841203cfad2c": {
            attributes: {id: "c67bd107-a843-4b68-8d54-841203cfad2c"},
            children: [{text: "Data 2"}],
            name: "td",
        },
        "rr-13-wide": {
            attributes: {id: "rr-13-wide", class: "level"},
            children: [{id: "rr-13-wide-h"}, {id: "rr-13-wide-table"}],
            name: "section",
        },
        "rr-13-wide-h": {
            attributes: {id: "rr-13-wide-h"},
            children: [{text: "13B. Table, Wide"}],
            name: "h3",
        },
        "rr-13-wide-table": {
            attributes: {
                id: "rr-13-wide-table",
                style: "border-collapse:collapse; width:99.6983%;",
            },
            children: [
                {id: "rr-13-wide-colgroup"},
                {id: "rr-13-wide-thead"},
                {id: "rr-13-wide-tbody"},
            ],
            name: "table",
        },
        "rr-13-wide-colgroup": {
            attributes: {id: "rr-13-wide-colgroup"},
            children: [{id: "rr-13-wide-col-1"}, {id: "rr-13-wide-col-2"}],
            name: "colgroup",
        },
        "rr-13-wide-col-1": {
            attributes: {
                id: "rr-13-wide-col-1",
                style: "width:39.6522%;",
            },
            children: [],
            name: "col",
        },
        "rr-13-wide-col-2": {
            attributes: {
                id: "rr-13-wide-col-2",
                style: "width:60.3478%;",
            },
            children: [],
            name: "col",
        },
        "rr-13-wide-thead": {
            attributes: {id: "rr-13-wide-thead"},
            children: [{id: "rr-13-wide-thead-tr"}],
            name: "thead",
        },
        "rr-13-wide-thead-tr": {
            attributes: {id: "rr-13-wide-thead-tr"},
            children: [{id: "rr-13-wide-th-1"}, {id: "rr-13-wide-th-2"}],
            name: "tr",
        },
        "rr-13-wide-th-1": {
            attributes: {id: "rr-13-wide-th-1"},
            children: [{text: "Kolonne 1"}],
            name: "th",
        },
        "rr-13-wide-th-2": {
            attributes: {id: "rr-13-wide-th-2"},
            children: [{text: "Kolonne 2"}],
            name: "th",
        },
        "rr-13-wide-tbody": {
            attributes: {id: "rr-13-wide-tbody"},
            children: [{id: "rr-13-wide-tbody-tr"}],
            name: "tbody",
        },
        "rr-13-wide-tbody-tr": {
            attributes: {id: "rr-13-wide-tbody-tr"},
            children: [{id: "rr-13-wide-td-1"}, {id: "rr-13-wide-td-2"}],
            name: "tr",
        },
        "rr-13-wide-td-1": {
            attributes: {id: "rr-13-wide-td-1"},
            children: [
                {
                    text: "Data 1 med en lang tekststreng som sprenger tilgjengelig plass: aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                },
            ],
            name: "td",
        },
        "rr-13-wide-td-2": {
            attributes: {id: "rr-13-wide-td-2"},
            children: [
                {
                    text: "Data 2 med en lang tekststreng som sprenger tilgjengelig plass: aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                },
            ],
            name: "td",
        },
        "rr-14": {
            attributes: {id: "rr-14", class: "level"},
            children: [
                {id: "rr-14-h"},
                {id: "263d62bb-01e5-42fd-b124-00543a2eed3d"},
            ],
            name: "section",
        },
        "rr-14-h": {
            attributes: {id: "rr-14-h"},
            children: [{text: "14. Booktags"}],
            name: "h3",
        },
        "263d62bb-01e5-42fd-b124-00543a2eed3d": {
            attributes: {
                class: "booktags",
                "data-print": "false",
                id: "263d62bb-01e5-42fd-b124-00543a2eed3d",
                parentId: "a-1-2",
            },
            children: [{id: "a-1-3"}, {id: "a-1-4"}],
            name: "ul",
        },
        "a-1-3": {
            attributes: {id: "a-1-3"},
            children: [{id: "80c1adca-f810-45ae-a97e-f8eda6fb69cf"}],
            name: "li",
        },
        "80c1adca-f810-45ae-a97e-f8eda6fb69cf": {
            attributes: {id: "80c1adca-f810-45ae-a97e-f8eda6fb69cf"},
            children: [{text: "Grenseoverskridende aksjebytte"}],
            name: "i",
        },
        "a-1-4": {
            attributes: {id: "a-1-4"},
            children: [{id: "ace162b8-689f-4c8b-9b77-03bcf1a7c18a"}],
            name: "li",
        },
        "ace162b8-689f-4c8b-9b77-03bcf1a7c18a": {
            attributes: {id: "ace162b8-689f-4c8b-9b77-03bcf1a7c18a"},
            children: [{text: "Aksjebytte, grenseoverskridende"}],
            name: "i",
        },
        "rr-15": {
            attributes: {id: "rr-15", class: "level"},
            children: [{id: "rr-15-h"}, {id: "rr-15-p"}],
            name: "section",
        },
        "rr-15-h": {
            attributes: {id: "rr-15-h"},
            children: [{text: "15. XFootnote"}],
            name: "h3",
        },
        "rr-15-p": {
            attributes: {id: "rr-15-p"},
            children: [{text: "Hover ikonet"}, {id: "rr-15-x"}],
            name: "p",
        },
        "rr-15-x": {
            attributes: {
                id: "rr-15-x",
                class: "dib-x-footnote",
                contenteditable: "false",
                "data-title":
                    "I samsvar med nr. 7.2.21 kan et foretak som del av sine regnskapsprinsipper velge å fortsette å anvende sikringsbokføringskravene i IAS 39 i stedet for kravene i kapittel 6 i denne standard.",
                title: "I samsvar med nr. 7.2.21 kan et foretak som del av sine regnskapsprinsipper velge å fortsette å anvende sikringsbokføringskravene i IAS 39 i stedet for kravene i kapittel 6 i denne standard.",
            },
            children: [],
            name: "span",
        },
        "rr-16": {
            attributes: {id: "rr-16", class: "level"},
            children: [{id: "rr-16-h"}, {id: "rr-16-pb"}],
            name: "section",
        },
        "rr-16-h": {
            attributes: {id: "rr-16-h"},
            children: [{text: "16. PageBreak"}],
            name: "h3",
        },
        "rr-16-pb": {
            attributes: {id: "rr-16-pb", class: "dib-x-pagebreak"},
            children: [],
            name: "div",
        },
        "aug-section": {
            attributes: {id: "aug-section", class: "level"},
            children: [
                {id: "aug-h2"},
                {id: "aug-acc"},
                {id: "aug-stikkord"},
                {id: "aug-iconlinks"},
            ],
            name: "section",
        },
        "aug-h2": {
            attributes: {id: "aug-h2"},
            children: [{text: "Augmentations"}],
            name: "h2",
        },
        "aug-acc": {
            attributes: {id: "aug-acc", class: "level"},
            children: [{id: "aug-acc-h"}],
            name: "section",
        },
        "aug-acc-h": {
            attributes: {id: "aug-acc-h"},
            children: [{text: "AccountingTable"}],
            name: "h3",
        },
        "aug-stikkord": {
            attributes: {id: "aug-stikkord", class: "level"},
            children: [{id: "aug-stikkord-h"}],
            name: "section",
        },
        "aug-stikkord-h": {
            attributes: {id: "aug-stikkord-h"},
            children: [{text: "Stikkord"}],
            name: "h3",
        },
        "aug-iconlinks": {
            attributes: {id: "aug-iconlinks", class: "level"},
            children: [{id: "aug-iconlinks-h"}],
            name: "section",
        },
        "aug-iconlinks-h": {
            attributes: {id: "aug-iconlinks-h"},
            children: [{text: "SectionIconLinks"}],
            name: "h3",
        },
    },
    tocroot: [{id: "toc-root;"}],
    toc: {
        "toc-root;": {
            attributes: {},
            children: [{id: "mock-root"}],
            type: "toc",
        },
        "mock-root": {
            attributes: {
                id: "mock-root",
                seg: "0",
                title: "Mock topic",
            },
            children: [{id: "rr-section"}, {id: "aug-section"}],
            name: "toc",
        },
        "rr-section": {
            attributes: {
                id: "rr-section",
                seg: "0",
                title: "Render Rules",
            },
            children: [],
            name: "toc",
        },
        "aug-section": {
            attributes: {
                id: "aug-section",
                seg: "0",
                title: "Augmentations",
            },
            children: [],
            name: "toc",
        },
    },
    elementdata: {
        "aug-acc": {
            accounting: [
                "0de3fc6f-82c9-44fe-9de7-377c4bafea53",
                "48786af6-d4b8-45c9-8791-c4211ff826c1",
                "e410c9d2-aa73-4e5a-98cf-7adf431aa006",
                "d714ffe2-1b43-4d7f-8a73-d578cf63f87a",
            ],
            tax: [
                "3f56e658-c2c3-4d1d-aad4-02fb69b733b5",
                "41d7aa28-e4ca-4528-ac90-0f796f269d09",
                "89e128d8-918a-4870-846e-cbe7e3272e47",
            ],
        },
        "aug-stikkord": {
            tags: [
                "tag-aksjeloven",
                "tag-bokforing",
                "tag-revisor",
                "tag-skatteloven",
            ],
        },
        "aug-iconlinks": {
            references: 15,
        },
    },
    elementuserdata: {},
    objects: {
        "13f64129-7f6d-4774-9656-9f5a04ebaf4b": {
            type: "linkdata",
            id: "13f64129-7f6d-4774-9656-9f5a04ebaf4b",
            data: {
                topicId: "a7dd0de9-131a-46dd-9e2c-0b1dd62ca1a2",
                segmentId: "",
                id: "",
                type: "nav",
                endPoint: 1,
                resourceTypeId: 5,
                viewType: 7,
                topicTypeId: "17",
                topicName: "Delårsrapportering oppstillinger - engelsk",
            },
        },
        "6f9d2059-d144-4115-837a-cfdc309cb3de": {
            type: "linkdata",
            id: "6f9d2059-d144-4115-837a-cfdc309cb3de",
            data: {
                topicId: "e4c21e2b-146d-4032-b9a2-bb9941e1158c",
                segmentId: "",
                id: "41731de5-2158-409a-84f3-6e4fb19017c2",
                type: "preview",
                endPoint: 1,
                resourceTypeId: 19,
                viewType: 0,
                topicTypeId: "29",
                topicName: "Uttalelser fra ledelsen",
            },
        },
        "a6b67036-25bc-4bf4-bfcf-3c4bd8dae113": {
            type: "linkdata",
            id: "a6b67036-25bc-4bf4-bfcf-3c4bd8dae113",
            data: {
                id: "",
                type: "href",
                endPoint: 1,
                resourceTypeId: 0,
                viewType: 0,
                topicTypeId: "0",
                topicName: "",
                href: "https://www.skatteetaten.no/",
            },
        },
        "dcd3409b-c0b4-4ede-9e42-38f4fd5d3a21": {
            type: "linkdata",
            id: "dcd3409b-c0b4-4ede-9e42-38f4fd5d3a21",
            data: {
                topicId: "e314cb10-1c1c-4251-b331-9face2e8f79c",
                segmentId: "",
                id: "",
                type: "nav",
                endPoint: 1,
                resourceTypeId: 19,
                viewType: 0,
                topicTypeId: "1001",
                topicName: "Portal KOSTRA-funksjoner",
            },
        },
        "eb9919d0-e903-4dbb-9b51-0f8cb2996170": {
            type: "linkdata",
            id: "eb9919d0-e903-4dbb-9b51-0f8cb2996170",
            data: {
                topicId: "da3db617-f9a3-4668-93e6-bbb2e37b928f",
                id: "",
                type: "auto-link",
                endPoint: 1,
                resourceTypeId: 23,
                viewType: 0,
                topicTypeId: "2",
                topicName: "Aksjeloven",
            },
        },
        "0de3fc6f-82c9-44fe-9de7-377c4bafea53": {
            type: "accline",
            id: "0de3fc6f-82c9-44fe-9de7-377c4bafea53",
            data: {
                id: "0de3fc6f-82c9-44fe-9de7-377c4bafea53",
                codeId: "1",
                name: "1 - Kjøp av varer og tjenester med fradragsrett (høy sats)",
                debetcredit: 1,
                accId: "1",
                typeId: "1",
                dataResourceId: "033464c1-4b05-4605-96c7-742ef8624b7f",
                dataId: "-251597003",
            },
        },
        "48786af6-d4b8-45c9-8791-c4211ff826c1": {
            type: "accline",
            id: "48786af6-d4b8-45c9-8791-c4211ff826c1",
            data: {
                id: "48786af6-d4b8-45c9-8791-c4211ff826c1",
                codeId: "3",
                name: "3 - Salg og uttak av varer og tjenester (høy sats)",
                debetcredit: 2,
                accId: "1",
                typeId: "1",
                dataResourceId: "033464c1-4b05-4605-96c7-742ef8624b7f",
                dataId: "-1488212731",
            },
        },
        "e410c9d2-aa73-4e5a-98cf-7adf431aa006": {
            type: "accline",
            id: "e410c9d2-aa73-4e5a-98cf-7adf431aa006",
            data: {
                id: "e410c9d2-aa73-4e5a-98cf-7adf431aa006",
                codeId: "10",
                name: "10 Immaterielle eiendeler o.l.",
                accId: "3",
                typeId: "2",
                dataResourceId: "c515967a-7b3d-4544-b566-532bc78875a6",
                dataId: "-667301400",
            },
        },
        "d714ffe2-1b43-4d7f-8a73-d578cf63f87a": {
            type: "accline",
            id: "d714ffe2-1b43-4d7f-8a73-d578cf63f87a",
            data: {
                id: "d714ffe2-1b43-4d7f-8a73-d578cf63f87a",
                codeId: "1000",
                name: "1000 Utvikling, ervervet",
                debetcredit: 1,
                accId: "3",
                typeId: "2",
                dataResourceId: "c515967a-7b3d-4544-b566-532bc78875a6",
                dataId: "-1033536211",
            },
        },
        "3f56e658-c2c3-4d1d-aad4-02fb69b733b5": {
            type: "taxline",
            id: "3f56e658-c2c3-4d1d-aad4-02fb69b733b5",
            data: {
                id: "aug-acc",
                taxId: "2",
                name: "Trekkplikt",
                accId: "2",
                dataResourceId: "d3dcc98b-ff78-40c9-a971-fa82f9f1e28c",
                dataId: "428720803",
            },
        },
        "41d7aa28-e4ca-4528-ac90-0f796f269d09": {
            type: "taxline",
            id: "41d7aa28-e4ca-4528-ac90-0f796f269d09",
            data: {
                id: "aug-acc",
                taxId: "4",
                name: "Opplysningsplikt",
                accId: "2",
                dataResourceId: "d3dcc98b-ff78-40c9-a971-fa82f9f1e28c",
                dataId: "-1033824201",
            },
        },
        "89e128d8-918a-4870-846e-cbe7e3272e47": {
            type: "taxline",
            id: "89e128d8-918a-4870-846e-cbe7e3272e47",
            data: {
                id: "aug-acc",
                taxId: "6",
                name: "Sykepenger",
                accId: "2",
                dataResourceId: "d3dcc98b-ff78-40c9-a971-fa82f9f1e28c",
                dataId: "72b31bcb-381c-4f6d-8de7-520d531a0d3a",
            },
        },
        "tag-aksjeloven": {
            type: "tag",
            id: "tag-aksjeloven",
            data: {
                id: "tag-aksjeloven",
                name: "Aksjeloven",
                tagtypeId: "1",
                language: "no",
            },
        },
        "tag-bokforing": {
            type: "tag",
            id: "tag-bokforing",
            data: {
                id: "tag-bokforing",
                name: "Bokføring",
                tagtypeId: "1",
                language: "no",
            },
        },
        "tag-revisor": {
            type: "tag",
            id: "tag-revisor",
            data: {
                id: "tag-revisor",
                name: "Revisor",
                tagtypeId: "1",
                language: "no",
            },
        },
        "tag-skatteloven": {
            type: "tag",
            id: "tag-skatteloven",
            data: {
                id: "tag-skatteloven",
                name: "Skatteloven",
                tagtypeId: "1",
                language: "no",
            },
        },
    },
    viewroot: [],
    showroot: [],
    genroot: [],
    variableroot: [],
    genobjectroot: [],
    relatedroot: [],
    collectionroot: [],
    defaultCollectionId: "",
    labels: [],
    defaultLabel: [],
};
